import { render } from "./App.vue?vue&type=template&id=b1cb5abc"
const script = {}

import "../public/css/site.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__